import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select } from '../../../common/components';
import messages from '../../messages';

const statuses = [
  { id: 0, value: 'all', label: <FormattedMessage {...messages.statusFilterLabelAll} /> },
  { id: 1, value: 'ongoing', label: <FormattedMessage {...messages.statusFilterLabelOngoing} /> },
  { id: 2, value: 'closed', label: <FormattedMessage {...messages.statusFilterLabelClosed} /> },
];

const S = {
  Select: styled(Select)`
    width: 100%;
  `,
};

const StatusFilter = ({ intl, value, onChange }) => (
  <S.Select
    id="status"
    label={intl.formatMessage(messages.statusFilterSelectLabel)}
    options={statuses}
    value={value}
    onChange={onChange}
  />
);

StatusFilter.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default injectIntl(StatusFilter);
